import request from '@/libs/request'
import { toast } from '../libs/utils'

// 线上报到生成二维码
export async function onlineCheckinMakeCode (params) {
  let data = await request.postJson('/pmc/patientCheckIn/createCheckinQrCode', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '线上报到生成二维码异常' })
    return false
  }
}
// 确认对账
export async function checkPriceAndChangeRemarks (params) {
  let data = await request.post('/order/orderCheckOrderInfo/updateReconciliation', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '确认对账异常' })
    return false
  }
}
// 修改备注信息
export async function changeRemarks (params) {
  let data = await request.post('/order/orderCheckOrderInfo/updateOrderCheckRemark', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '修改备注异常' })
    return false
  }
}
// 查看修改实际费用记录
export async function getChangePriceRecord (params) {
  let data = await request.post('/bdc/commonRecordChangelog/queryByIdAndTypePage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取修改记录异常' })
    return false
  }
}
// 获取线上报到患者列表
export async function getOnlineCheckinList (params) {
  let data = await request.post('/pmc/patientCheckIn/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取患者列表异常' })
    return false
  }
}
// 获取患者知情同意书
export async function getPatientAgreeBook (params) {
  let data = await request.get('/pmc/online_registration/findById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取患者知情同意书异常' })
    return false
  }
}
// 修改患者知情同意书
export async function changePatientAgreeBook (params) {
  let data = await request.postJson('/pmc/online_registration/report', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '修改患者知情同意书异常' })
    return false
  }
}
// 生成支付二维码
export async function makePayCode (params) {
  let data = await request.post('/order/orderCheckOrderInfo/createPayQrCode', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '生成支付二维码异常' })
    return false
  }
}